<template>
  <div :class="cssClass">
    <div class="c-hint__icon">
      <Icon2 variant="hint" :size="32" />
    </div>
    <div class="c-hint__inner">
      <div class="c-hint__content">
        <p v-if="$slots.title" class="c-hint__title">
          <slot name="title"></slot>
        </p>
        <slot></slot>
      </div>
      <div v-if="$slots.btn" class="c-hint__btn">
        <slot name="btn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';

export default {
  props: {
    variant: {
      type: String,
      required: false
    }
  },
  components: {
    Icon2
  },
  computed: {
    cssClass() {
      return {
        'c-hint': true,
        ['c-hint--' + this.variant]: this.variant
      };
    }
  }
};
</script>
